import { jsx } from "react/jsx-runtime";
import { useRef, useCallback, useEffect } from "react";
import { Search } from "./components/Search.js";
import { Stack } from "@mui/material";
const SearchPanel = ({ onSearch, setFilter, mobileView }) => {
  const ref = useRef({ onSearch, setFilter });
  ref.current = { onSearch, setFilter };
  const handleSearch = useCallback((str) => {
    var _a, _b, _c, _d;
    (_b = (_a = ref.current).setFilter) == null || _b.call(_a, str), (_d = (_c = ref.current).onSearch) == null || _d.call(_c, str);
  }, []);
  return useEffect(() => () => {
    var _a;
    return (_a = ref.current) == null ? void 0 : _a.setFilter("");
  }, []), /* @__PURE__ */ jsx(Stack, { sx: mobileView ? { paddingX: 18, paddingY: 12 } : {}, children: /* @__PURE__ */ jsx(Search, { onSearch: handleSearch, mobileView }) });
};
export {
  SearchPanel
};
//# sourceMappingURL=SearchPanel.js.map
